import { render, staticRenderFns } from "./modal-approver-response.vue?vue&type=template&id=1ca7bc3c&scoped=true&"
import script from "./modal-approver-response.vue?vue&type=script&lang=js&"
export * from "./modal-approver-response.vue?vue&type=script&lang=js&"
import style0 from "./modal-approver-response.vue?vue&type=style&index=0&id=1ca7bc3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7bc3c",
  null
  
)

export default component.exports